import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Map } from '../models/map';
import { IShape } from '../map/interfaces/IShape';
import { environment } from '../../environments/environment';


@Injectable({
    providedIn: 'root',
})
export class MapService {
    baseUrl: string = environment.apiUrl;

    constructor(private HttpClient: HttpClient) {}

    saveMap(shapes: IShape[]): Observable<Map> {
        return this.HttpClient.post<Map>(
            this.baseUrl + '/map',
            shapes
        );
    }

    getMap(): Observable<Map> {
        return this.HttpClient.get<Map>(
            this.baseUrl + '/map'
        );
    }
}
